import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type ColorCorrectOptionProps = {
  isChecked: boolean;
  onChange: (checked: boolean) => void;
};

function ColorCorrectOption(props: ColorCorrectOptionProps) {
  const { isChecked, onChange } = props;

  return (
    <div className="color_correction_option">
      <h3 className="title">Color Correction</h3>
      <p className="desc">
        We hand adjust each image for density, color, contrast, and saturation for the best prints
        possible from your images.
      </p>
      <div className="checkbox">
        <input
          type="checkbox"
          id="color_correction"
          checked={isChecked}
          onChange={() => onChange(!isChecked)}
        />
        <label htmlFor="color_correction">
          {isChecked && <FontAwesomeIcon icon={['far', 'check-square']} size="2x" />}
          {!isChecked && <FontAwesomeIcon icon={['far', 'square']} size="2x" />}
          <span>Yes, color correct my images.</span>
        </label>
      </div>
    </div>
  );
}

export default ColorCorrectOption;
